export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14217.414a20fe.jpg";